import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'

export const WeChatImg = styled(GatsbyImage)`
  display: flex;
  width: 90%;
  margin: 20px;
  background-color: white;

  img {
    object-fit: cover;
  }
`

export const WeChatModalInnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
